import React from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import FetchInputSelectOptions from '../../FetchInputSelectOptions';
import InputSelect from '../InputSelect';
import { fetchCurriculaAdmissionMethod } from 'services/options_services';

const AdmissionMethodInputSelect = ({ params, submitOnChange, ...props }) => {
  const { submitForm } = useFormikContext();

  return (
    <FetchInputSelectOptions
      params={params}
      fetchOptions={fetchCurriculaAdmissionMethod}
    >
      {({ options, isLoading }) => (
        <InputSelect
          name="forma_ingresso"
          label="Nome do processo seletivo"
          placeholder="Selecionar"
          options={options}
          isLoading={isLoading}
          getOptionValue={(d) => d.id}
          getOptionLabel={(d) => d.name}
          onChange={() => submitOnChange && submitForm()}
          {...props}
        />
      )}
    </FetchInputSelectOptions>
  );
};

AdmissionMethodInputSelect.propTypes = {
  params: PropTypes.objectOf(PropTypes.node),
  submitOnChange: PropTypes.bool,
};

AdmissionMethodInputSelect.defaultProps = {
  params: {},
  submitOnChange: false,
};

export default AdmissionMethodInputSelect;
